
import { WebDesignComponent } from './descriptionComponents/web-design.component';
import { SeoComponent } from './descriptionComponents/seo.component';
import { LogoComponent } from './descriptionComponents/logo.component';
import { MobileComponent } from './descriptionComponents/mobile.component';
import { BrandingComponent } from './descriptionComponents/branding.component';
import { MarketingComponent } from './descriptionComponents/marketing.component';


export const SERVICES_ROUTER = [
  { path: 'web', component: WebDesignComponent},
  { path: 'seo', component: SeoComponent},
  { path: 'logo', component: LogoComponent },
  { path: 'mobile', component: MobileComponent},
  { path: 'branding', component: BrandingComponent},
  { path: 'marketing', component: MarketingComponent}
];




// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/services/services.routes.ts